<!--Calendar Starts-->
<section id="calendar">
    <div class="row">
      <div class="col-sm-12">
        <div class="content-header">Calendar</div>
        <p class="content-sub-header">This is the most advanced example having various features. This
          example lists all the events on the calendar with Add new event functionality.</p>
      </div>
    </div>
    <ng-template #modalContent let-close="close">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalData?.action }}</h5>
        <button type="button" class="close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form action="#" class="form form-horizontal">
          <div class="form-body">
            <div class="form-group">
              <label>Event Title:</label>
              <input type="text" name="event-title" class="form-control" [(ngModel)]="modalData?.event.title"
                (keyup)="refresh.next()">
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label>Primary Color:</label>
                  <input type="color" name="primary-color" [(ngModel)]="modalData?.event.color.primary"
                    (change)="refresh.next()">
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label>Secondary Color:</label>
                  <input type="color" name="secondary-color" [(ngModel)]="modalData?.event.color.secondary"
                    (change)="refresh.next()">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label>Starts At:</label>
                  <mwl-demo-utils-date-time-picker name="starts-at" [(ngModel)]="modalData?.event.start"
                    (ngModelChange)="refresh.next()" placeholder="Not set">
                  </mwl-demo-utils-date-time-picker>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label>Ends At:</label>
                  <mwl-demo-utils-date-time-picker name="ends-at" [(ngModel)]="modalData?.event.end"
                    (ngModelChange)="refresh.next()" placeholder="Not set">
                  </mwl-demo-utils-date-time-picker>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close()">OK</button>
      </div>
    </ng-template>
  
    <div class="card">
      <div class="card-content">
        <div class="card-body">
          <div class="d-sm-flex justify-content-between align-items-center mb-3">
            <div class="text-center text-sm-left mb-2 mb-sm-0">
              <div class="btn-group d-none d-lg-block">
                <a class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate">
                  Previous
                </a>
                <a class="btn btn-danger" mwlCalendarToday [(viewDate)]="viewDate">
                  Today
                </a>
                <a class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate">
                  Next
                </a>
              </div>
  
              <div class="btn-group d-block d-lg-none">
                <a class="btn btn-primary ft-chevron-left" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate">
                  <i class="icon icon-arrows-left"></i>
                </a>
                <a class="btn btn-danger ft-calendar" mwlCalendarToday [(viewDate)]="viewDate">
                  <i class="icon icon-arrows-sign-down"></i>
                </a>
                <a class="btn btn-primary ft-chevron-right" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate">
                  <i class="icon icon-arrows-right"></i>
                </a>
              </div>
            </div>
            <div class="text-center mb-2 mb-sm-0">
              <h6 class="text-uppercase mb-0">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h6>
            </div>
            <div class="text-center text-sm-right">
              <div class="btn-group d-none d-sm-none d-md-none d-lg-block">
                <a class="btn btn-primary" (click)="view = 'month'" [class.active]="view === 'month'">
                  Month
                </a>
                <a class="btn btn-primary" (click)="view = 'week'" [class.active]="view === 'week'">
                  Week
                </a>
                <a class="btn btn-primary" (click)="view = 'day'" [class.active]="view === 'day'">
                  Day
                </a>
              </div>
  
              <div class="btn-group d-block d-sm-block d-md-block d-lg-none">
                <a class="btn btn-primary btn-icon-icon" (click)="view = 'month'" [class.active]="view === 'month'">
                  <i class="fa fa-th"></i>
                </a>
                <a class="btn btn-primary btn-icon-icon" (click)="view = 'week'" [class.active]="view === 'week'">
                  <i class="fa fa-columns"></i>
                </a>
                <a class="btn btn-primary btn-icon-icon" (click)="view = 'day'" [class.active]="view === 'day'">
                  <i class="fa fa-th-list"></i>
                </a>
              </div>
  
            </div>
          </div>
          <div class="row mb-2">
            <!-- <div class="col-12">
              <button class="btn btn-primary float-right" (click)="addEvent()">
                Add Event
              </button>
            </div> -->
          </div>
  
          <div [ngSwitch]="view">
            <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
              [activeDayIsOpen]="activeDayIsOpen" (dayClicked)="dayClicked($event.day)"
              (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)">
            </mwl-calendar-month-view>
            <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
              (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)">
            </mwl-calendar-week-view>
            <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
              (eventClicked)="handleEvent('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)">
            </mwl-calendar-day-view>
          </div>
        </div>
      </div>
    </div>
  